var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "app-side-menu",
    { attrs: { "min-width": 18, "fixed-menu": false } },
    [
      _c(
        "aside",
        {
          staticClass: "menu",
          attrs: { slot: "side-menu" },
          slot: "side-menu",
        },
        [
          _c("p", { staticClass: "menu-label" }, [
            _c("span", { staticClass: "title is-6" }, [
              _vm._v(" Item No: " + _vm._s(_vm.entityName) + " "),
            ]),
          ]),
          _c("ul", { staticClass: "menu-list" }, [
            _c("li", [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.entityType == "LAB",
                      expression: "entityType=='LAB'",
                    },
                  ],
                },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          name: _vm.routeTypes.ItemDetail.name,
                          query: _vm.$route.query,
                        },
                        "active-class": "is-active",
                        exact: "",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          class: {
                            "has-badge-danger has-badge-small has-badge-rounded has-badge-offset2":
                              _vm.$v.labourGroup.$error,
                          },
                          attrs: {
                            "data-badge": _vm.$v.labourGroup.$error ? "" : null,
                          },
                        },
                        [_vm._v(" Detail Info ")]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.entityType == "PRT",
                      expression: "entityType=='PRT'",
                    },
                  ],
                },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          name: _vm.routeTypes.ItemDetail.name,
                          query: _vm.$route.query,
                        },
                        "active-class": "is-active",
                        exact: "",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          class: {
                            "has-badge-danger has-badge-small has-badge-rounded has-badge-offset2":
                              _vm.$v.partGroup.$error,
                          },
                          attrs: {
                            "data-badge": _vm.$v.partGroup.$error ? "" : null,
                          },
                        },
                        [_vm._v(" Detail Info ")]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.entityType == "OPG",
                      expression: "entityType=='OPG'",
                    },
                  ],
                },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          name: _vm.routeTypes.ItemDetail.name,
                          query: _vm.$route.query,
                        },
                        "active-class": "is-active",
                        exact: "",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          class: {
                            "has-badge-danger has-badge-small has-badge-rounded has-badge-offset2":
                              _vm.$v.opgGroup.$error,
                          },
                          attrs: {
                            "data-badge": _vm.$v.opgGroup.$error ? "" : null,
                          },
                        },
                        [_vm._v(" Detail Info ")]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.entityType == "MISC",
                      expression: "entityType=='MISC'",
                    },
                  ],
                },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          name: _vm.routeTypes.ItemDetail.name,
                          query: _vm.$route.query,
                        },
                        "active-class": "is-active",
                        exact: "",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          class: {
                            "has-badge-danger has-badge-small has-badge-rounded has-badge-offset2":
                              _vm.$v.miscGroup.$error,
                          },
                          attrs: {
                            "data-badge": _vm.$v.miscGroup.$error ? "" : null,
                          },
                        },
                        [_vm._v(" Detail Info ")]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.entityType == "SUBL",
                      expression: "entityType=='SUBL'",
                    },
                  ],
                },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          name: _vm.routeTypes.ItemDetail.name,
                          query: _vm.$route.query,
                        },
                        "active-class": "is-active",
                        exact: "",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          class: {
                            "has-badge-danger has-badge-small has-badge-rounded has-badge-offset2":
                              _vm.$v.subletGroup.$error,
                          },
                          attrs: {
                            "data-badge": _vm.$v.subletGroup.$error ? "" : null,
                          },
                        },
                        [_vm._v(" Detail Info ")]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }